export * from './StrapiTrendingProductsWidget'
